import { atom } from 'recoil';
import type { Lfa_Conversion_Update__Input } from '~/graphql/types';

export type ServicesFeedbackType = Lfa_Conversion_Update__Input | null;

const servicesFeedbackState = atom<ServicesFeedbackType>({
  key: 'servicesFeedbackState',
  default: null,
});

export default servicesFeedbackState;
